import React, { useEffect, useId, useState } from 'react'
import { useLoading } from '../../context/LoadingProvider/useLoading'
import { getLobbyOrder, updateLobbyOrder } from '../../services/lobbyOrder'
import {game, modalTag} from './types'
import {
  DragDropContext,
  Draggable,
  DraggingStyle,
  Droppable,
  DropResult,
  NotDraggingStyle,
} from "react-beautiful-dnd";
import FloatingButton from '../../components/UI/FloatingButton';
import { sendSystemLog, useAuth } from '../../context/AuthProvider/useAuth';
import { serverUrl } from '../../services/api';
import {CSVLink} from "react-csv";
import {PlusOutlined, TagsOutlined} from "@ant-design/icons";
import {Button} from "antd";
import ModalTagsSelector from "./ModalPTTagsSelector";

const reorder = (
  list: game[],
  startIndex: number,
  endIndex: number
): game[] => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 20;

const getItemStyle = (
  isDragging: boolean,
  draggableStyle: DraggingStyle | NotDraggingStyle | undefined
): React.CSSProperties => ({
  userSelect: "none",
  padding: '10px 20px',
  margin: `0 0 8px 0`,
  border: '1px solid rgba(0, 0, 0)',
  color: isDragging ? 'white' : '#000',
  backgroundColor: isDragging ? '#000' : 'transparent',
  fontWeight: 'bold',
  ...draggableStyle
});

const getListStyle = (isDraggingOver: boolean): React.CSSProperties => ({
  backgroundColor: isDraggingOver ? 'rgba(0, 0, 0, 0.0588235294)': '#FFF',
  padding: '20px 30px',
  transition: 'all 0.3s',
  width: 1000,
});

const getImageLink = (img: string) => {
  return img.replace('images/','imagens/') || '';
}

function index(props: { accessLevel: string }) {
  const {canEdit} = useAuth()
  const loading = useLoading()
  const [order, setOrder] = useState<game[] | never>([])
  const [initialOrder, setInitialOrder] = useState<game[] | never>([])
  const log = {
    log_type: 'visited',
    log_object: 'game_orderings'
  }
  const [modal, setModal] = useState<modalTag>({
    action: false,
    objectType: false,
    title: "",
    tags:  [],
    allTags: []
  })



  useEffect(() => {
    sendSystemLog(log);
  }, [])

  async function onRefresh() {
    const res = await getLobbyOrder()
    setOrder(res)
    setInitialOrder(res)
  }

  useEffect(() => {
    (async () => {
      loading.addLoading()
      await onRefresh();
      loading.removeLoading()
    })()
  }, [])

  useEffect(() => {
    console.log("order: ")
    console.log(order)
  }, [order])

  useEffect(() => {
    console.log("initialOrder: ")
    console.log(initialOrder)
  }, [initialOrder])

  const dummy = ()=> {

  }

  const onDragEnd = (result: DropResult): void => {

    if (!result.destination || !canEdit) {
      return;
    }

    const items: game[] = reorder(
      order,
      result.source.index,
      result.destination.index
    );

    setOrder(items);
  };

  const replaceGame = (game: game): void => {

    console.log("Entering ReplaceGame")
    let games: game[] = []
    order.forEach((tmpgame) => {
      if (game.title === tmpgame.title){
        games.push(game)
      } else {
        games.push(tmpgame)
      }
    })

    setOrder(games);
  };

  const onSubmit = async () => {
    loading.addLoading()
    let payload: typeof order = []
    if(order.length > 0) {
      payload = order.map((item, index) => ({...item, order: `${index}`}))
    }
    await updateLobbyOrder(payload)
    const res = await getLobbyOrder()
    setOrder(res)
    setInitialOrder(res)
    loading.removeLoading()
  }
  const closeTagsModal = async(tags: string[]) => {
    console.log("Entering closeTagsModal " + JSON.stringify(tags))
    console.log("Title: " + modal.title)
    console.log("Initial: " + JSON.stringify(initialOrder))
    let game: game | null = getGame(modal.title)
    if (game != null)
      { // @ts-ignore
        if (JSON.stringify(tags)!==JSON.stringify(game.tags)) {
          game.tags = tags
          replaceGame(game)
        }
      }
    setModal({...modal, action: false})
    console.log("Initial: " + JSON.stringify(initialOrder))
    console.log("Order:" + JSON.stringify(order))
  }

  const getGame = (title : string) => {
    let retVal : game = {
      title: "",
      id: "",
      order: "-1",
      image: "",
      tags: []
    }
    order.forEach((game) => {
      if (game.title === title){
        retVal.id = game.id
        retVal.title = game.title
        retVal.order = game.order
        retVal.image = game.image
        retVal.tags = game.tags

      }
    })
    return retVal.order === "-1"?null:retVal
  }
  const getAllUsedTags = () :string[] => {
    let retVal : string[] = []
    let tagList : string = ""
    order.forEach((game) => {
      if (game.tags){
        game.tags.forEach((tag) => {
          if (!tagList.includes("|" + tag + "|")){
            retVal.push(tag)
            tagList = tagList + "|" + tag + "|"
          }
        })
      }
    })
    return retVal
  }

  const headers = [
    { label: 'Order', key: 'order' },
    { label: 'Title', key: 'title' },
    { label: 'Tags', key: 'tags' },
  ];

  return (
    <div className="lobby-order">
    <meta name="viewport" content="width=device-width, initial-scale=.75"/>
      <ModalTagsSelector
          visible={modal.action}
          title={"Manage Tags for " + modal.title}
          tags={modal.tags}
          allTags={modal.allTags}
          onClose={closeTagsModal}
      />

      <FloatingButton
      text="Save"
      onClick={onSubmit}
      disabled={(JSON.stringify(initialOrder) === JSON.stringify(order))|| !canEdit}
    />
      <CSVLink style={{display: order?.length > 0 ? 'flex' : 'none'}}
               filename={"Lobby_order.csv"}
               className="floating-button-left"
               data={order}
               headers={headers}>
        <PlusOutlined style={{color: '#FFF', fontSize: window.innerWidth > 600 ? 20 : 16}} />
        <div className="floating-button__text">
          Export CSV
        </div>
      </CSVLink>


      {order && order.length > 0 ? (
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot): JSX.Element => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
              >
                {order.map((item, index) => (
                  <Draggable key={item.title} draggableId={item.title} index={index}>
                    {(provided, snapshot): JSX.Element => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className="lobby-order__drag"
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                      >
                        <div className="lobby-order__drag__img">
                          <img src={serverUrl + '/' + item.image} />
                        </div>
                        <div className="lobby-order__drag__text">
                          <h3>#{index + 1} {item.title}</h3> <p>{item.tags && item.tags.length > 0?"Tags: " + JSON.stringify(item.tags):""}</p>
                        </div>
                        <Button
                            onClick={() => setModal({...modal, action: true, title: item.title, tags: item.tags, allTags: getAllUsedTags()})}
                            type='primary'
                            style={{backgroundColor: '#2fa4e7'}}
                        >
                            <TagsOutlined style={{ fontSize: '16px', color: '#FFF' }} />
                        </Button>


                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      ) : null}
      <div className="lobby-order__hint">
        The order represents the position in which games are displayed in the Game Terminal.

        Simply drag a game downwards or upwards and click Save at the bottom of the page to change the position of each game!
      </div>
    </div>
  )
}

export default index;
